import styled from "styled-components";
import { Box } from "orcs-design-system";

export const StyledForm = styled(Box)(({ highlight, theme }) => {
  return `
    background: ${highlight ? theme.colors.primary10 : "none"};
    margin-top: ${highlight ? theme.space.s : "0"};
  `;
});
